var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6935 6.06549C0.5645 6.20883 0.5 6.37366 0.5 6.55999C0.5 6.74633 0.5645 6.91116 0.6935 7.05449L4.8215 11.1825C4.96483 11.3115 5.12967 11.376 5.316 11.376C5.50233 11.376 5.66717 11.3115 5.8105 11.1825C5.9395 11.0392 6.004 10.8743 6.004 10.688C6.004 10.5017 5.9395 10.3368 5.8105 10.1935L2.1555 6.55999L5.8105 2.92649C5.9395 2.78316 6.004 2.61833 6.004 2.43199C6.004 2.24566 5.9395 2.08082 5.8105 1.93749C5.66717 1.80849 5.50233 1.74399 5.316 1.74399C5.12967 1.74399 4.96483 1.80849 4.8215 1.93749L0.6935 6.06549Z",
    fill: "#003768"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.88,
    height: 12,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.5 12.56)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.6c49313f4e6170f5d6fe37c20aad962d.svg";
export { ForwardRef as ReactComponent };